import { render, staticRenderFns } from "./TaskDetailsInfo.vue?vue&type=template&id=3739a7d0&scoped=true"
import script from "./TaskDetailsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDetailsInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TaskDetailsInfo.vue?vue&type=style&index=0&id=3739a7d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3739a7d0",
  null
  
)

export default component.exports